import React, { Component, Fragment } from 'react';
import { Header } from 'semantic-ui-react';
import { connect } from 'react-redux';
import * as _ from 'lodash';

import { AssignSiteGrid } from './AssignSiteGrid';
import { Filter, Main } from 'Containers';
import { DirtyWrapper } from 'Components';
import * as actions from './../state/actions';
import { resetDirty } from 'State/dirtyTracking/actions';

class AssignSitePageContainer extends Component {
  static path = '/usersetup/assignusers/:id/:userName';
  componentDidMount() {
    const { id } = this.props.match.params;
    this.props.getSitesHaveAccess(id);
  }

  handleAssignSubmit = () => {
    const { id } = this.props.match.params;
    //get data into the format userid [sites]
    const sites = _.filter(this.props.assignSiteData, x => {
      return x.Allowed === 1;
    });

    this.props.postSitesHaveAccess({
      UserId: id,
      AccessibleSiteInfos: sites,
    });
    this.props.resetDirty();
  };
  getRootUrl = () => {
    return '/usersetup';
  };
  getMainProps = showDirtyConfirm => {
    const { loading, isSubmitting, isReadOnly } = this.props;
    let toolbox = {
      backButtonProps: {
        path: this.getRootUrl(),
      },
      rightButtons: [
        {
          content: 'Save',
          onClick: this.handleAssignSubmit,
          disabled: loading || isSubmitting || isReadOnly,
        },
      ],
      shown: true,
    };
    return {
      toolbox,
    };
  };
  componentWillUnmount() {
    this.props.clearAssignSiteData();
    this.props.resetDirty();
  }

  render() {
    const {
      assignSiteData,
      isReadOnly,
      loading,
      initialData,
      checkAllChecked,
    } = this.props;
    const { userName } = this.props.match.params;
    return (
      <Fragment>
        <Filter title={'Assign Site(s) to a User'} />
        <DirtyWrapper isReadOnly={isReadOnly}>
          {showDirtyConfirm => (
            <Main
              {...this.getMainProps(showDirtyConfirm)}
              shouldNotUsePageWidth
            >
              <Header
                icon="building outline"
                style={{
                  color: '#df5a17',
                }}
                content={`Assign sites to user - ${userName}`}
              />
              <AssignSiteGrid
                assignSiteData={assignSiteData}
                handleAssignSubmit={this.props.handleAssignSubmit}
                loading={loading}
                isReadOnly={isReadOnly}
                initialData={initialData}
                checkAllChecked={checkAllChecked}
              />
            </Main>
          )}
        </DirtyWrapper>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ UserSetupState }) => {
  return {
    initialData: UserSetupState.initialData,
    assignSiteData: UserSetupState.assignSiteData,
    loading: UserSetupState.isAssignGridLoading,
    isSubmitting: UserSetupState.result.isSubmitting,
    checkAllChecked: UserSetupState.checkAllChecked,
  };
};

export const AssignSitePage = connect(
  mapStateToProps,
  { ...actions, resetDirty }
)(AssignSitePageContainer);



// WEBPACK FOOTER //
// ./src/pages/usersetup/components/AssignSitePage.js